import { getOptionalBaseUrl } from "@/config/url"

const COVAL_TRANSPORT_BASE_URL = getOptionalBaseUrl(
  process.env.COVAL_TRANSPORT_BASE_URL,
)
const SAME_ORIGIN_TRANSPORT_ENABLED =
  process.env.NEXT_PUBLIC_TRANSPORT_SAME_ORIGIN_ENABLED === "true"

interface GetTransportBaseUrlOptions {
  locationOrigin?: string
  serverBaseUrl?: string
}

export function getTransportBaseUrl({
  locationOrigin,
  serverBaseUrl,
}: GetTransportBaseUrlOptions = {}) {
  const resolvedServerBaseUrl = getOptionalBaseUrl(
    serverBaseUrl ?? COVAL_TRANSPORT_BASE_URL,
  )
  const resolvedLocationOrigin = getOptionalBaseUrl(
    SAME_ORIGIN_TRANSPORT_ENABLED
      ? (locationOrigin ??
          (typeof window !== "undefined" ? window.location.origin : undefined))
      : undefined,
  )

  return resolvedLocationOrigin ?? resolvedServerBaseUrl
}

export const TRANSPORT_BASE = getTransportBaseUrl()

export const hasTransportBaseUrl = COVAL_TRANSPORT_BASE_URL !== undefined
